import React from "react";
import { PageHero, PageBody } from "./_shared";
import { usePoly } from "./PolyLayout";
import FacilitiesGrid from "@/components/FacilitiesGrid";

export default function Facilities() {
  const data = usePoly();
  const items = data?.facilities || [];
  return (
    <div data-testid="poly-facilities">
      <PageHero eyebrow="Campus" title="World-class Facilities" accent="amber" />
      <PageBody>
        <FacilitiesGrid
          items={items}
          testidPrefix="poly-facilities"
          accentChipClass="bg-amber-500/10 text-amber-700 ring-1 ring-amber-500/20"
        />
      </PageBody>
    </div>
  );
}
